import React from 'react';
import ArtistSelector from './ArtistSelector';
import ArtistList from './ArtistList';
import GenreSelector from './GenreSelector';

const EditTrackModal = ({
  editTitle,
  setEditTitle,
  artistRole,
  setArtistRole,
  artistName,
  setArtistName,
  artists,
  artists2,
  setArtists2,
  removeArtist2,
  autoArtists,
  handleAutoArtists,
  genre,
  genresList,
  filterGenres,
  setGenre,
  autoGenre,
  handleAutoGenre,
  clipStart,
  setClipStart,
  isrc,
  setIsrc,
  isrcDisabled,
  setIsrcDisabled,
  copyright,
  setCopyright,
  activeRadio1,
  setActiveRadio1,
  trackLanguage,
  setTrackLanguage,
  languages,
  autoLanguage,
  handleAutoLanguage,
  editTrackIndex,
  explicit,
  setExplicit,
  lyrics,
  setLyrics,
  updateTrack
}) => {
  return (
    <div className="modal fade" id="editTrackModal" tabIndex="-1" aria-labelledby="editTrackModalLabel" aria-hidden="true">
      <div className="modal-dialog modal-lg modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h1 className="modal-title fs-5" id="editTrackModalLabel">Edit Track</h1>
            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div className="modal-body">
            <div className="row">
              <div className="col-12 mt-3">
                <div className="dash-form-group">
                  <label>Title</label>
                  <input 
                    type="text" 
                    value={editTitle} 
                    onChange={(e) => setEditTitle(e.target.value)} 
                    placeholder='Title' 
                    className='dash-form-input' 
                  />
                </div>
              </div>
              
              <ArtistSelector 
                artistRole={artistRole}
                setArtistRole={setArtistRole}
                artistName={artistName}
                setArtistName={setArtistName}
                artists={artists}
                addArtist={() => setArtists2([...artists2, {artistId: artistName.artistId, name: artistName.name, role: artistRole}])}
              />
              
              <div className="col-12">
                <div className="form-check dash-form-check mt-2">
                  <input 
                    className="form-check-input" 
                    type="checkbox" 
                    checked={autoArtists} 
                    onChange={handleAutoArtists} 
                    id="autoArtists" 
                  />
                  <label className="form-check-label" htmlFor="autoArtists">
                    Add Artists from Release
                  </label>
                </div>
              </div>
              
              <div className="col-12">
                <ArtistList 
                  artists={artists2} 
                  removeArtist={removeArtist2} 
                />
              </div>
              
              <div className="col-md-6 mt-3">
                <GenreSelector 
                  genre={genre}
                  genresList={genresList}
                  onChange={filterGenres}
                  onSelect={setGenre}
                />
                <div className="form-check dash-form-check mt-2">
                  <input 
                    className="form-check-input" 
                    type="checkbox" 
                    checked={autoGenre} 
                    onChange={handleAutoGenre} 
                    id="autoGenre" 
                  />
                  <label className="form-check-label" htmlFor="autoGenre">
                    Use Genre from Release
                  </label>
                </div>
              </div>
              
              <div className="col-md-6 mt-3">
                <div className="dash-form-group">
                  <label>Preview/Clip Start Time</label>
                  <input 
                    type="text" 
                    value={clipStart} 
                    onChange={(e) => setClipStart(e.target.value)} 
                    placeholder='mm:ss' 
                    className='dash-form-input' 
                  />
                </div>
              </div>
              
              <div className="col-md-6 mt-3">
                <div className="dash-form-group">
                  <label>ISRC</label>
                  <input 
                    type="text" 
                    placeholder='LL-LLL-NN-NNNNN' 
                    className={`dash-form-input ${isrcDisabled && 'disabled'}`} 
                    disabled={isrcDisabled} 
                    value={isrc}
                    onChange={(e) => setIsrc(e.target.value)}
                  />
                </div>
                <div className="form-check dash-form-check mt-2">
                  <input 
                    className="form-check-input" 
                    type="checkbox" 
                    checked={isrcDisabled} 
                    onChange={() => setIsrcDisabled(!isrcDisabled)} 
                    id="isrc" 
                  />
                  <label className="form-check-label" htmlFor="isrc">
                    I don't have one, assign a ISRC code to this release automatically
                  </label>
                </div>
              </div>
              
              <div className="col-md-6 mt-3">
                <div className="dash-form-group">
                  <label>Copyright</label>
                  <select 
                    value={copyright} 
                    onChange={(e) => setCopyright(e.target.value)} 
                    className='dash-form-select'
                  >
                    <option>Original Song</option>
                    <option>Public Domain</option>
                  </select>
                </div>
              </div>
              
              <div className="col-md-6 mt-3">
                <div className="dash-form-group">
                  <label>Language of Lyrics</label>
                  <div className="form-check dash-form-check">
                    <input 
                      className="form-check-input" 
                      checked={activeRadio1 === 1} 
                      onChange={() => {setActiveRadio1(1); setTrackLanguage('Instrumental')}} 
                      type="radio" 
                      name="trackRadios" 
                      id="tr1" 
                    />
                    <label className="form-check-label" htmlFor="tr1">
                      Instrumental
                    </label>
                  </div>
                  <div className="form-check dash-form-check">
                    <input 
                      className="form-check-input" 
                      checked={activeRadio1 === 2} 
                      onChange={() => {setActiveRadio1(2); setTrackLanguage(languages[0])}} 
                      type="radio" 
                      name="trackRadios" 
                      id="tr2" 
                    />
                    <label className="form-check-label" htmlFor="tr2">
                      Select Language
                    </label>
                  </div>
                </div>
                
                {activeRadio1 === 2 && (
                  <div className="dash-form-group mt-3">
                    <select 
                      value={trackLanguage} 
                      onChange={(e) => setTrackLanguage(e.target.value)} 
                      className='dash-form-select'
                    >
                      {languages.map((language, i) => (
                        <option key={i}>{language}</option>
                      ))}
                    </select>
                  </div>
                )}
                
                {editTrackIndex > 0 && (
                  <div className="col-12">
                    <div className="form-check dash-form-check mt-2">
                      <input 
                        className="form-check-input" 
                        type="checkbox" 
                        checked={autoLanguage} 
                        onChange={handleAutoLanguage} 
                        id="autoLanguage" 
                      />
                      <label className="form-check-label" htmlFor="autoLanguage">
                        Copy From Previous Track
                      </label>
                    </div>
                  </div>
                )}
              </div>
              
              <div className="col-md-6 mt-3">
                <div className="dash-form-group">
                  <label>Explicit</label>
                  <div className="form-check dash-form-check">
                    <input 
                      className="form-check-input" 
                      type="radio" 
                      name="editEx" 
                      id="editEx1"
                      checked={explicit === 'Yes'}
                      onChange={() => setExplicit('Yes')} 
                    />
                    <label className="form-check-label" htmlFor="editEx1">
                      Yes
                    </label>
                  </div>
                  <div className="form-check dash-form-check">
                    <input 
                      className="form-check-input" 
                      type="radio" 
                      name="editEx"
                      id="editEx2" 
                      checked={explicit === 'No'}
                      onChange={() => setExplicit('No')}
                    />
                    <label className="form-check-label" htmlFor="editEx2">
                      No
                    </label>
                  </div>
                </div>
              </div>
              
              <div className="col-12 mt-3">
                <div className="dash-form-group">
                  <label>Lyrics</label>
                  <textarea 
                    value={lyrics} 
                    onChange={e => setLyrics(e.target.value)} 
                    className='dash-form-textarea'
                  ></textarea>
                </div>
              </div>
              
              <div className="col-12 mt-3">
                <div className="dash-form-btns">
                  <button 
                    className='dash-form-btn' 
                    data-bs-dismiss="modal"
                    onClick={updateTrack}
                  >
                    Update
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditTrackModal; 